import React from 'react';
import { Card } from '@dev-go4ellis/go4-design-system';
import './HowMathWorks.scss';

const HowMathWorks = () => (
  <Card padding="lg" flat className="pl-math">
    <div className="pl-math__label">How the math works</div>
    <div className="pl-math__rows">
      <div className="pl-math__row">
        <span className="pl-math__key">Your rate × hours × trainers</span>
        <span className="pl-math__val">Base pay</span>
      </div>
      <div className="pl-math__divider" />
      <div className="pl-math__row">
        <span className="pl-math__key">Go4 service fee</span>
        <span className="pl-math__val pl-math__val--teal">+ 17.5%</span>
      </div>
      <div className="pl-math__divider" />
      <div className="pl-math__row">
        <span className="pl-math__total-key">Total you pay</span>
        <span className="pl-math__total-val">Base + fee</span>
      </div>
    </div>
    <p className="pl-math__foot">That's the whole model. There is no onboarding cost, placement premium, or annual platform fee underneath it.</p>
  </Card>
);

export default HowMathWorks;
